<template>
  <v-img
    height="80vh"
    :src="banner.src"
  >
    <v-overlay
      absolute
      opacity="0.85"
      z-index="1"
      class="text-center"
    >
      <div class="my-4">
        <h1
          class="font-weight-black"
          style="white-space: pre-line;"
          v-text="mobile ? '社團法人\n中華服務品質發展協會' : '社團法人中華服務品質發展協會'">
        </h1>
        <h2 class="mt-2">專業教育顧問</h2>
      </div>
      <v-btn
        color="primary"
        large
        :aria-label="banner.text"
        @click="banner.action"
      >
        <strong>{{ banner.text }}</strong>
      </v-btn>
      <div class="mt-2">
        <small>營業時間：平日 09:00 – 17:30</small>
      </div>
    </v-overlay>
  </v-img>
</template>

<script>
export default {
  computed: {
    mobile() {
      return this.$store.state.mobile;
    },
    fb() {
      return this.$store.state.fb;
    },
    banner() {
      return {
        title: '社團法人中華服務品質發展協會',
        text: '與我們聯絡',
        action: () => { window.open(this.fb, '_blank','noopener') },
        src: require('@/assets/img/banner.jpg')
      };
    },
  },
}
</script>
